import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import theme from 'styled-theming';
import darken from 'polished/lib/color/darken';
import 'react';
import { maxWidthLayoutStyles } from '../../utils/styleHelpers.js';
import { jsx } from 'react/jsx-runtime';

var _templateObject, _templateObject2;
const PageHeaderContainer = /*#__PURE__*/styled.header.withConfig({
  displayName: "pageHeader__PageHeaderContainer",
  componentId: "sc-s52d4r-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  display: flex;\n  flex-shrink: 0;\n  padding: ", ";\n\n  background: ", ";\n\n  color: ", ";\n\n  *:not(:disabled) {\n    *:focus-visible {\n      box-shadow: ", ";\n    }\n  }\n\n  /** @todo remove from here and solve more generally */\n  [data-hidemobile] {\n    display: none;\n  }\n\n  ", " {\n    padding: ", ";\n\n    [data-hidemobile] {\n      display: inline-flex;\n      vertical-align: middle;\n    }\n  }\n\n  ", " {\n    padding: ", ";\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return "".concat(theme.spacing.quarterSpacing, " ").concat(theme.spacing.halfSpacing);
}, _ref2 => {
  let {
    theme: {
      colors
    }
  } = _ref2;
  return theme('mode', {
    light: colors.accents.dark,
    dark: darken(0.1, colors.accents.dark)
  });
}, _ref3 => {
  let {
    theme: {
      colors
    }
  } = _ref3;
  return theme('mode', {
    light: colors.contrastText,
    dark: colors.text
  });
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return "0 0 0 2px ".concat(theme.colors.primary.light);
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.mediaQueries.md;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return "".concat(theme.spacing.halfSpacing, " ").concat(theme.spacing.baseSpacing);
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.mediaQueries.lg;
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return "".concat(theme.spacing.halfSpacing, " ").concat(theme.spacing.doubleSpacing);
});
const PageHeaderInner = /*#__PURE__*/styled.div.withConfig({
  displayName: "pageHeader__PageHeaderInner",
  componentId: "sc-s52d4r-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  > * {\n    display: flex;\n    flex-basis: 33.3%;\n    justify-content: center;\n\n    &:first-child {\n      justify-content: flex-start;\n    }\n\n    &:last-child {\n      justify-content: flex-end;\n    }\n\n    &:only-child {\n      flex-basis: 100%;\n      justify-content: center;\n    }\n  }\n\n  ", "\n"])), _ref9 => {
  let {
    fullWidth
  } = _ref9;
  return !fullWidth && maxWidthLayoutStyles;
});
const PageHeader = _ref10 => {
  let {
    children,
    fullWidth,
    ...rest
  } = _ref10;
  return /*#__PURE__*/jsx(PageHeaderContainer, {
    ...rest,
    children: /*#__PURE__*/jsx(PageHeaderInner, {
      fullWidth: fullWidth,
      children: children
    })
  });
};

export { PageHeader };
